import React from "react";

interface EnvironmentProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
}

const Environment: React.FC<EnvironmentProps> = ({
  fill = "#3C3C3C",
  stroke = "none",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5732 18.525L10.7232 14.3L13.7732 11.3H15.7232V13.15L17.9982 13.5C18.1816 13.0333 18.3274 12.55 18.4357 12.05C18.5441 11.55 18.5982 11.0333 18.5982 10.5C18.5982 9.01667 18.2274 7.6625 17.4857 6.4375C16.7441 5.2125 15.7732 4.25 14.5732 3.55V6.5H11.5732V9.5H9.57324V12.5H7.54824L5.57324 9.5H4.57324V10.5L2.79824 12.475C3.23158 14.2083 4.16908 15.65 5.61074 16.8C7.05241 17.95 8.70658 18.525 10.5732 18.525ZM14.5732 12.5H11.5732V10.5H14.5732V12.5ZM14.5732 6.5H16.5982L15.5982 9.5H13.5482L14.5732 6.5ZM10.5732 20.5C9.18991 20.5 7.88991 20.2375 6.67324 19.7125C5.45658 19.1875 4.39824 18.475 3.49824 17.575C2.59824 16.675 1.88574 15.6167 1.36074 14.4C0.835742 13.1833 0.573242 11.8833 0.573242 10.5C0.573242 9.11667 0.835742 7.81667 1.36074 6.6C1.88574 5.38333 2.59824 4.325 3.49824 3.425C4.39824 2.525 5.45658 1.8125 6.67324 1.2875C7.88991 0.7625 9.18991 0.5 10.5732 0.5C11.9566 0.5 13.2566 0.7625 14.4732 1.2875C15.6899 1.8125 16.7482 2.525 17.6482 3.425C18.5482 4.325 19.2607 5.38333 19.7857 6.6C20.3107 7.81667 20.5732 9.11667 20.5732 10.5C20.5732 11.8833 20.3107 13.1833 19.7857 14.4C19.2607 15.6167 18.5482 16.675 17.6482 17.575C16.7482 18.475 15.6899 19.1875 14.4732 19.7125C13.2566 20.2375 11.9566 20.5 10.5732 20.5Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default Environment;
